import type { PracticePreference } from '@region13/shared-types'
import { resubmissionWarning } from '../lib/practicePrefsCopy'
import { DEFAULT_LEAGUE_TZ } from '../lib/practiceDate'

/** Tells a coach, BEFORE they save, that revising costs them their place in
 *  line (spec D8). Renders nothing until a submission exists.
 *
 *  Deliberately a plain paragraph, not `role="status"`: that role is a live
 *  region meant to announce a transient update after the page has settled.
 *  This text is present from first render and never changes in response to
 *  an in-page action, so a live region either goes unannounced (already
 *  populated when inserted) or announces near page load - the opposite of
 *  the point, which is to be read right before Save is pressed. */
export function ResubmissionBanner({ prefs }: { prefs: PracticePreference | null }) {
  const warning = prefs ? resubmissionWarning(prefs.submittedAt, prefs.revision, DEFAULT_LEAGUE_TZ) : null
  if (!warning || !prefs) return null
  return (
    <p className="rounded-md bg-canvas px-3 py-2 text-xs text-ink-soft">
      {warning}
      {prefs.revision > 1 ? ` This is revision ${prefs.revision}.` : ''}
    </p>
  )
}
